module.exports = __webpack_public_path__ + "s/img/Power_D_1.dcc16b19.jpg";